import { createTheme } from "@mui/material";

const theme = createTheme({
  palette: {
    primary: {
      main: "#A07B4F",
      contrastText: "#fff",
    },
    secondary: {
      main: "#2D2D2C",
      contrastText: "#fff",
    },
    background: {
      default: "#f3f3f3",
    },
  },
  typography: {
    fontFamily: "\"Helvetica Neue\", \"Inter\", Arial, sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;
